import { mapGetters, mapActions } from 'vuex';
import agentNav from '@/agent/components/agentnav/agent-nav.vue';
import agentBrokerage from '@/agent/components/agentbrokerage/agent-brokerage.vue';
import brokerageBanner from '@/agent/components/brokeragebanner/brokerage-banner.vue';
import agentRegion from '@/agent/components/agentregion/agent-region.vue';
import brokerageNearby from '@/agent/components/brokeragenearby/brokerage-nearby.vue';
import agentReview from '@/agent/components/agentreview/agent-review.vue';
import dapInfo from '@/agent/components/dapinfo/dap-info.vue';
import agentTransaction from '@/agent/components/agenttransaction/agent-transaction.vue';
import agentTransactionDetail from '@/agent/components/agenttransactiondetail/agent-transaction-detail.vue';
import mvtDialog from '@/common/components/mvtdialog/mvt-dialog.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import mvtCardAgent from '@/common/components/mvtcardagent/mvt-cardagent.vue';
import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';
import mvtSelect from '@/common/components/mvtselect/mvt-select.vue';
import mvtRating from '@/common/components/mvtrating/mvt-rating.vue';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtToastCenter from '@/common/components/mvttoastcenter/mvt-toastcenter.vue';

export default {
    name: 'pageDap',
    inject: ['$eventBus'],
    components: {
        agentRegion,
        agentBrokerage,
        brokerageBanner,
        brokerageNearby,
        agentNav,
        agentReview,
        dapInfo,
        agentTransaction,
        agentTransactionDetail,
        mvtDialog,
        mvtTextbox,
        mvtInputGeo,
        mvtCardAgent,
        mvtCheckbox,
        mvtSelect,
        mvtRating,
        mvtCollapse,
        mvtNearby,
        mvtDialogCenter,
        mvtHeader,
        mvtLazyload,
        mvtHotleadForm,
        mvtFooter,
        mvtToastCenter
    },
    mixins: [lazyCarouselCheckMixin],
    data() {
        return {
            review: {
                title: '',
                service: '',
                year: '',
                showCityState: false,
                comment: '',
                address: {
                    text: '',
                    geo: null,
                },
                rating: 0,
            },
            report: {
                email: '',
                subject: '',
                description: '',
            },
            reviewData: {},
            yearData: [],
            serviceData: [
                { value: 0, text: this.molang('search.common.reviewService') },
                { value: 2, text: 'Helped me sell my home/lot/land' },
                { value: 3, text: "Listed my home, but it didn't sell" },
                { value: 1, text: 'Helped me buy a home/lot/land' },
                { value: 10, text: 'Showed me homes or lots' },
                { value: 11, text: 'Helped me buy and sell homes' },
                { value: 12, text: 'Helped me with a rental opportunity' },
                { value: 4, text: "We talked or met but it didn't work" },
                { value: 6, text: 'Never responded to my inquiry' },
            ],
            showCityStateData: [
                {
                    text: this.molang('search.common.reviewShowCityState'),
                    value: true,
                },
            ],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getCityNewListings', 'getSplit']),
        ...mapGetters('dap', ['dap']),

        getMSPlink() {
            return this.glb.appUrl + this.dap.geo.newPath;
        },
        reviewSummary() {
            if (this.dap.reviews && this.dap.reviews.length > 0) {
                const sum = {
                    star1: 0,
                    star2: 0,
                    star3: 0,
                    star4: 0,
                    star5: 0,
                    star0: 0,
                    total: 0,
                };

                this.dap.reviews.reduce((prev, curr) => {
                    const key = 'star' + Math.ceil(curr.rating);
                    sum.total += curr.rating;
                    if (prev[key] >= 0) {
                        prev[key]++;
                    }
                    return prev;
                }, sum);

                const total = sum.star0 + sum.star1 + sum.star2 + sum.star3 + sum.star4 + sum.star5;
                // get percentage for each star
                sum.star1per = (sum.star1 / total) * 100;
                sum.star2per = (sum.star2 / total) * 100;
                sum.star3per = (sum.star3 / total) * 100;
                sum.star4per = (sum.star4 / total) * 100;
                sum.star5per = (sum.star5 / total) * 100;
                sum.star0per = (sum.star0 / total) * 100;
                sum.starAvg = sum.total / this.dap.reviews.length;
                return sum;
            }
            return null;
        },
        hotleadOpt() {
            return {
                hotleadTitle: `Ask ${this.dap.agentType === 1 ? `${this.dap.firstName} ` : ''}a Question`,
                hotleadSub: `You can request a call, a home tour, or real estate help from ${this.dap.firstName}`,
                hotleadType: this.glb.isMobile ? 'InlineHotleadInAgentProfilePage_sellerMOBILE' : 'InlineHotleadInAgentProfilePage_seller',
                buttonText: 'Ask a Question',
                showZipcode: true,
                requestAgentId: this.dap.agentId,
                hideProfile: true
            };
        },
    },
    methods: {
        ...mapActions('glb', ['sendZendeskRequest']),
        ...mapActions('dap', ['sendReview', 'sendReport']),

        completedNew() {
            this.$refs.lazyloadNew.ready();
        },

        hideReview() {
            // your feedback
            this.review.title = '';
            this.review.service = '';
            this.review.year = '';
            this.review.showCityState = false;
            this.review.comment = '';
            this.review.address = {
                text: '',
                geo: null,
            };
            this.review.rating = 0;
        },
        submitReview() {
            // your submit
            const that = this;
            const data = {
                userId: {
                    id: this.dap.agentId,
                    idType: 'NOVA',
                },
                rating: this.review.rating,
                reviewTitle: this.review.title,
                reviewText: this.review.comment,
                serviceInfo: {
                    serviceType: this.review.service,
                    fullAddress: this.review.address.text,
                    date: new Date(this.review.year + '-07-01'),
                },
                publishZipcodeOrCity: this.review.showCityState,
            };
            this.formState = 'submitting';
            this.sendReview(data)
                .then((resp) => {
                    let status = resp.ok;
                    if (status == 1) {
                        that.formState = 'submitted';
                        this.$eventBus.$off('eventbus-dialog-close');
                        this.$emit('comfirmed');
                        that.$eventBus.$emit('dialog-center', {
                            name: 'mvtConfirm',
                            opt: {
                                title: 'THANK YOU!',
                                message: 'We have sent your request. Expect a call/email shortly.',
                                propertyData: this.review.address,
                            },
                            trigger: that.$options.name,
                        });
                    } else {
                        that.formState = 'rejected';
                        that.$eventBus.$emit('dialog-center', {
                            name: 'mvtConfirm',
                            opt: {
                                title: 'ERROR',
                                message: status && (status.detailMessage || status.msg),
                            },
                            trigger: that.$options.name,
                        });
                    }
                    location.reload(true);
                })
                .catch((err) => {
                    that.formState = '';
                });
        },
        hideReport() {
            //your feedback
            this.report.email = '';
            this.report.subject = '';
            this.report.description = '';
            this.reviewData = {};
        },
        submitReport() {
            const that = this;
            const data = {
                reviewId: this.reviewData._id,
                subject: this.report.subject,
                email: this.report.email,
                description: this.report.description,
                userId: this.dap.agentId,
            };
            this.formState = 'submitting';
            this.sendReport(data)
                .then((resp) => {
                    let status = resp.ok;
                    if (status == 1) {
                        that.formState = 'submitted';
                        this.$eventBus.$off('eventbus-dialog-close');
                        this.$emit('comfirmed');
                        that.$eventBus.$emit('dialog-center', {
                            name: 'mvtConfirm',
                            opt: {
                                title: 'Thank you for your feedback!',
                            },
                            trigger: that.$options.name,
                        });
                    } else {
                        that.formState = 'rejected';
                        that.$eventBus.$emit('dialog-center', {
                            name: 'mvtConfirm',
                            opt: {
                                title: 'ERROR',
                                message: status && (status.detailMessage || status.msg),
                            },
                            trigger: that.$options.name,
                        });
                    }
                })
                .catch((err) => {
                    that.formState = '';
                });
        },
        openReview() {
            this.$refs.review.show('agentReview', this.$options.name);
        },
        openReport(data) {
            this.$refs.report.show();
            this.reviewData = data.data;
        },
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: `Ask ${this.dap.agentType === 1 ? `${this.dap.firstName} ` : ''}a Question`,
                    hotleadSub: `You can request a call, a home tour, or real estate help from ${this.dap.firstName}`,
                    hotleadType: this.glb.isMobile ? 'InlineHotleadInAgentProfilePage_sellerMOBILE' : 'InlineHotleadInAgentProfilePage_seller',
                    buttonText: 'Ask a Question',
                    showZipcode: true,
                    agentData: this.dap,
                    requestAgentId: this.dap.agentId,
                },
            });
        },
        getYears() {
            const max = new Date().getFullYear();
            const min = max - 22;
            const years = [];
            years.push({ value: 0, text: 'Year of service' });
            for (let i = max; i >= min; i--) {
                years.push({ value: i, text: i });
            }
            return years;
        },
    },
    watch: {
        address(newValue) {
            const that = this;
            if (newValue && newValue.geo) {
                this.hotlead.address = newValue.text;
                const addressComponents = newValue.geo.address_components;
                for (let comp of addressComponents) {
                    if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(comp.long_name)) {
                        this.hotlead.zipcode = comp.long_name;
                        const event = new Event('change');
                        setTimeout(function () {
                            that.$refs.zipcode && that.$refs.zipcode.dispatchEvent(event);
                        }, 10);
                        break;
                    }
                }
            }
        },
    },
    beforeMount() {
        this.yearData = this.getYears();
    },
    mounted() {
        const that = this;
        this.$eventBus.$on('eventbus-agent-openreview', function (data) {
            that.openReview();
        });
        this.$eventBus.$on('eventbus-agent-openreport', function (data) {
            that.openReport(data);
        });
    },
};
